// Register
export const UPDATE_PHONE_PREFIX = "UPDATE_PHONE_PREFIX";
export const ADD_RECAPTCHA = "ADD_RECAPTCHA";
export const REDIRECT_TO_CONFIRM = "REDIRECT_TO_CONFIRM";
export const ADD_USER_MODEL = "ADD_USER_MODEL";
export const ADD_ERROR_CONFIRM = "ADD_ERROR_CONFIRM";
export const ADD_ERROR_REGISTER = "ADD_ERROR_REGISTER";
